export interface FontSizeProps {
  fontSize?: string | number
}

export const useFontSizeProps = () => ({
  fontSize: {
    type: [String, Number],
    default: null,
  },
})

export function useFontSize(props: FontSizeProps) {
  const fontSizeStyles = computed(() => {
    if (props.fontSize) {
      return {
        fontSize: convertToUnit(props.fontSize),
      }
    }

    return {}
  })

  return {
    fontSizeStyles,
  }
}
